import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const faqs = [
  {
    q: "Do the kits fit in standard carry-on luggage?",
    a: "Yes. All our systems are mathematically designed to tessellate perfectly within standard international carry-on dimensions (21 x 14 x 9 inches)."
  },
  {
    q: "Are the materials waterproof?",
    a: "They are highly water-resistant. We use DWR-coated ballistic nylon and weatherproof YKK zippers, which will protect your gear from spills and rain, though they are not meant for submersion."
  },
  {
    q: "What is your warranty policy?",
    a: "We offer a Lifetime Guarantee on all craftsmanship and hardware. If a seam rips or a zipper breaks under normal travel conditions, we repair or replace it."
  }
];

const FaqShipping = () => {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <section className="py-20 bg-parchment-light border-y border-cobalt/10">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16">
        
        {/* FAQ Section */}
        <div>
          <h2 className="text-3xl font-bold mb-8 flex items-center gap-3">
            <SafeIcon icon={FiIcons.FiHelpCircle} className="text-amber" />
            Intelligence Briefing
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-cobalt/20 pb-4">
                <button 
                  className="w-full text-left flex justify-between items-center py-2 font-bold text-lg hover:text-amber transition-colors"
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                >
                  {faq.q}
                  <SafeIcon 
                    icon={openFaq === index ? FiIcons.FiMinus : FiIcons.FiPlus} 
                    className="text-cobalt" 
                  />
                </button>
                <AnimatePresence>
                  {openFaq === index && (
                    <motion.div 
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      <p className="pt-2 text-ink-light font-serif italic">
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>

        {/* Shipping & Returns */}
        <div className="bg-white p-8 journal-border">
          <h2 className="text-2xl font-bold mb-6 flex items-center gap-3 border-b border-cobalt/20 pb-4">
            <SafeIcon icon={FiIcons.FiTruck} className="text-cobalt" />
            Logistics (Shipping & Returns)
          </h2>
          
          <div className="space-y-6 text-sm">
            <div>
              <h4 className="font-bold uppercase tracking-wider text-amber mb-2">Global Dispatch</h4>
              <p className="text-ink-light">
                We ship to 140+ countries. Orders typically process within 24 hours. Standard global transit times range from 3-7 business days depending on customs.
              </p>
            </div>
            
            <div>
              <h4 className="font-bold uppercase tracking-wider text-amber mb-2">The 30-Day Evaluation</h4>
              <p className="text-ink-light">
                Test the gear. Pack it. Feel the materials. If it doesn't revolutionize your packing process within 30 days, return it for a full refund. No interrogations.
              </p>
            </div>

            <div className="pt-4 flex gap-4">
              <SafeIcon icon={FiIcons.FiShield} className="text-3xl text-cobalt/30" />
              <SafeIcon icon={FiIcons.FiGlobe} className="text-3xl text-cobalt/30" />
              <SafeIcon icon={FiIcons.FiAward} className="text-3xl text-cobalt/30" />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FaqShipping;